/**
 * util functions for scrolling
 */

/**
 * Center a child element within a container's viewport if it's not already in view
 */
export function centerInView(child: HTMLElement) {
  const container = child.offsetParent as HTMLElement;
  container.scrollTop =
    child.offsetTop - container.clientHeight / 2 + child.offsetHeight / 2;
}
